(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offering-actions"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('aether-donation-presets')) {
  customElements.define('aether-donation-presets', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-donation-amount]');
        if (!button || !this.contains(button)) return;
        const input = this.closest('form')?.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.donationAmount;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        input.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["photo-demo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('session-photo-demo')) {
  customElements.define('session-photo-demo', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        window.addEventListener('pageshow', this.onPageShow);
        this.onPageShow();
        return;
      }
      this.initialized = true;
      const dialog = this.querySelector('dialog');
      const openButton = this.querySelector('.photo-demo__open');
      const variantSelect = this.querySelector('[data-membership-variant-select]');
      const variantInput = this.querySelector('input[name="id"]');
      const variantPrice = this.querySelector('.pd__price');
      const variantSummary = this.querySelector('[data-membership-variant-summary]');
      const syncVariant = () => {
        if (!variantSelect) return true;
        const option = variantSelect.selectedOptions[0];
        if (!option || option.disabled) {
          openButton.disabled = true;
          return false;
        }
        variantInput.value = option.value;
        variantPrice.textContent = option.dataset.price;
        if (variantSummary) variantSummary.textContent = option.textContent.trim();
        openButton.disabled = false;
        return true;
      };
      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          syncVariant();
          this.clearConsent();
        });
        syncVariant();
      }
      openButton.addEventListener('click', () => {
        if (syncVariant()) dialog.showModal();
      });
      this.querySelector('.photo-demo__close').addEventListener('click', () => dialog.close());
      const inputs = this.querySelectorAll('input[type=file]');
      const panel = this.querySelector('.photo-demo__preview');
      const img = this.querySelector('img');
      const status = this.querySelector('.photo-demo__status');
      const next = this.querySelector('.photo-demo__continue');
      const form = this.querySelector('form');
      const consent = this.querySelector('[data-early-start-consent]');
      const consentTimestamp = this.querySelector('[data-consent-timestamp]');
      const consentStatement = this.querySelector('[data-consent-statement]');
      const consentVersion = this.querySelector('[data-consent-version]');
      const consentLabel = this.querySelector('[data-consent-label]');
      const consentFields = [consentTimestamp, consentStatement, consentVersion];
      let photoLoading = false;
      let photoReady = false;
      let submitting = false;
      const hasConsent = () => consent.checked && !!consentTimestamp.value && consentFields.every(input => !input.disabled);
      const syncButton = () => {
        const option = variantSelect && variantSelect.selectedOptions[0];
        const variantUnavailable = variantSelect && (!option || option.disabled);
        next.disabled = !hasConsent() || photoLoading || submitting || !photoReady || !!variantUnavailable;
      };
      this.clearConsent = () => {
        consent.checked = false;
        consentTimestamp.value = '';
        consentFields.forEach(input => { input.disabled = true; });
        syncButton();
      };
      consent.addEventListener('change', () => {
        if (!consent.checked) {
          this.clearConsent();
          return;
        }
        consentTimestamp.value = new Date().toISOString();
        consentStatement.value = consentLabel.textContent.trim();
        consentFields.forEach(input => { input.disabled = false; });
        syncButton();
      });
      const sync = () => {
        const hasPhoto = [...inputs].some(input => input.files.length);
        if (!hasPhoto) photoReady = false;
        inputs.forEach((input, index) => {input.disabled = false; input.required = !hasPhoto && index === 0;});
        syncButton();
      };
      const reset = (keepInput = null) => {
        this.version = (this.version || 0) + 1;
        if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
        this.objectUrl = null;
        img.removeAttribute('src');
        panel.hidden = true;
        photoLoading = false;
        photoReady = false;

        inputs.forEach(input => { if (input !== keepInput) input.value = ''; });
        sync();
      };
      this.resetPhoto = reset;
      this.onPageShow = () => {
        submitting = false;
        this.clearConsent();
        syncVariant();
        if ([...inputs].some(input => input.files.length)) sync();
        else reset();
        status.textContent = '';
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.onPageShow();
      form.addEventListener('reset', () => {
        queueMicrotask(() => {
          reset();
          this.onPageShow();
        });
      });
      inputs.forEach(input => input.addEventListener('change', async () => {
        const file = input.files[0];
        if (!file) {reset(); return;}
        reset(input);
        status.textContent = '';
        if (!['image/jpeg','image/png','image/webp'].includes(file.type)) {reset();status.textContent = status.dataset.invalid; return;}
        if (file.size > 10 * 1024 * 1024) {reset();status.textContent = status.dataset.large; return;}
        const version = this.version;
        const url = URL.createObjectURL(file);
        this.objectUrl = url;
        img.src = url;
        photoLoading = true;
        syncButton();
        status.textContent = status.dataset.loading;
        try { await img.decode(); } catch {
          if (version === this.version) { reset(); status.textContent = status.dataset.error; }
          return;
        }
        if (version !== this.version) return;
        this.querySelector('.photo-demo__name').textContent = file.name;
        panel.hidden = false;
        photoLoading = false;
        photoReady = true;
        syncButton();
        status.textContent = status.dataset.ready;
      }));
      this.querySelector('.photo-demo__remove').addEventListener('click', () => {reset();status.textContent = status.dataset.removed;});
      form.addEventListener('submit', (event) => {
        if (submitting) {
          event.preventDefault();
          return;
        }
        if (!syncVariant()) {
          event.preventDefault();
          variantSelect.focus();
          return;
        }
        sync();
        if (!hasConsent()) {
          event.preventDefault();
          this.clearConsent();
          consent.reportValidity();
          consent.focus();
          return;
        }
        if (photoLoading || !photoReady) {
          event.preventDefault();
          status.textContent = photoLoading ? status.dataset.loading : status.dataset.required;
          form.reportValidity();
          return;
        }
        const fields = [...this.querySelectorAll('.photo-demo__fields input')].filter(input => !input.disabled);
        for (const field of fields) {
          if (field.type === 'text' || field.type === 'email') field.value = field.value.trim();
          if (!field.reportValidity()) {event.preventDefault();field.focus();return;}
        }
        if (!form.reportValidity()) {event.preventDefault(); return;}
        inputs.forEach(input => { if (!input.files.length) input.disabled = true; });
        submitting = true;
        syncButton();
        status.textContent = status.dataset.complete;
      });
    }
    disconnectedCallback() {
      window.removeEventListener('pageshow', this.onPageShow);
      if (this.resetPhoto) this.resetPhoto();
      if (this.clearConsent) this.clearConsent();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["support-menu"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('aether-help'))customElements.define('aether-help',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;this.ready=true;this.copy=JSON.parse(this.querySelector('[data-ah-copy]').textContent);Object.values(this.copy).forEach(copy=>Object.keys(copy).forEach(key=>{const decoder=document.createElement('textarea');decoder.innerHTML=copy[key];copy[key]=decoder.value}));this.lang='en';this.path=['language'];
  this.panel=this.querySelector('dialog');this.heading=this.querySelector('h2');this.intro=this.querySelector('.ah-intro');this.content=this.querySelector('.ah-content');this.launch=this.querySelector('.ah-launch');
  this.launch.addEventListener('click',()=>{this.render();this.panel.showModal();this.launch.setAttribute('aria-expanded','true');this.heading.focus()});
  this.querySelector('.ah-close').addEventListener('click',()=>this.panel.close());
  this.panel.addEventListener('close',()=>{this.launch.setAttribute('aria-expanded','false');this.launch.focus()});
  this.querySelector('[data-back]').addEventListener('click',()=>{if(this.path.length>1)this.path.pop();this.render()});
  this.querySelector('[data-home]').addEventListener('click',()=>{this.path=['language','topics'];this.render()});
  this.querySelector('[data-language]').addEventListener('click',()=>{this.path=['language'];this.render()});
  this.querySelector('[data-contact]').addEventListener('click',()=>this.go('contact'));
  this.querySelector('.ah-return').addEventListener('click',()=>{const chat=document.querySelector('shopify-chat');if(chat?.close)chat.close();else chat?.removeAttribute('open');this.endHandoff();this.launch.click()});
  document.documentElement.classList.add('ah-ready');this.render();
 }
 go(page){this.path.push(page);this.render()}
 choice(text,action,lang){const button=document.createElement('button');button.type='button';button.className='ah-choice';button.textContent=text;if(lang)button.lang=lang;button.addEventListener('click',action);this.content.append(button)}
 link(text,url){const a=document.createElement('a');a.className='ah-choice';a.textContent=text;a.href=url;this.content.append(a)}
 render(){
  const c=this.copy[this.lang],page=this.path.at(-1);this.panel.lang=page==='language'?'en':this.lang;this.content.replaceChildren();this.intro.textContent='';this.querySelector('.ah-footer').hidden=page==='language';
  this.querySelector('[data-back]').textContent='‹ '+c.back;this.querySelector('[data-back]').hidden=this.path.length===1;
  this.querySelector('[data-home]').textContent=c.home;this.querySelector('[data-home]').hidden=page==='language'||page==='topics';
  this.querySelector('[data-language]').textContent=c.language;this.querySelector('[data-contact]').textContent=c.contact;this.querySelector('.ah-close').setAttribute('aria-label',c.close);this.querySelector('.ah-return').textContent=c.return_help;
  if(page==='language'){
   this.heading.textContent=this.querySelector('[data-ah-language-title]').content.textContent;this.intro.textContent=this.querySelector('[data-ah-language-note]').content.textContent;
   Object.keys(this.copy).forEach(lang=>this.choice(this.copy[lang].name,()=>{this.lang=lang;this.path=['language','topics'];this.render()},lang));
  }else if(page==='topics'){
   this.heading.textContent=c.title;this.intro.textContent=c.intro;['sessions','membership','orders'].forEach(topic=>this.choice(c[topic],()=>this.go(topic)));
  }else if(['sessions','membership','orders'].includes(page)){
   this.heading.textContent=c[page];this.intro.textContent=c.questions;const groups={sessions:[0,1],membership:[2],orders:[3,4]};groups[page].forEach(i=>this.choice(c['q'+i],()=>this.go('answer:'+i)));
  }else if(page.startsWith('answer:')){
   const i=Number(page.split(':')[1]);this.heading.textContent=c['q'+i];const p=document.createElement('p');p.className='ah-answer';p.textContent=c['a'+i];this.content.append(p);
   if(i===2)this.link(c.membership,'/products/aetherservants-family-membership');this.choice(c.contact,()=>this.go('contact'));
  }else{
   this.heading.textContent=c.contact;this.intro.textContent=c.contact_note;this.choice(c.inbox,()=>this.handoff());if(this.dataset.telegram)this.link(c.telegram,this.dataset.telegram);this.link(c.form,'/pages/contact');this.link('Instagram','https://www.instagram.com/aetherservants/');
  }
  this.panel.scrollTop=0;if(this.panel.open)this.heading.focus();
 }
 async handoff(){
  const chat=document.querySelector('shopify-chat');if(!chat){this.link(this.copy[this.lang].form,'/pages/contact');return}
  this.panel.close();document.documentElement.classList.add('ah-inbox');this.querySelector('.ah-return').hidden=false;
  if(typeof chat.show==='function')chat.show();else chat.setAttribute('open','');
  this.observer?.disconnect();this.observer=new MutationObserver(()=>{if(!chat.hasAttribute('open'))this.endHandoff()});this.observer.observe(chat,{attributes:true,attributeFilter:['open']});
 }
 endHandoff(){this.observer?.disconnect();document.documentElement.classList.remove('ah-inbox');this.querySelector('.ah-return').hidden=true}
 disconnectedCallback(){this.observer?.disconnect()}
});
  } catch(e) { console.error(e); }
})();

})();
